import { ENSEMBLE_PROVIDER_LOOKUP, ENSEMBLE_FORM } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import ensembleConfig from './ensembleConfig';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token ea0cf433992a401f3046984b45fd229ee8d90f4e',
  staging: 'Token fa3c270d74500943b2db0de25b309bb6265ca45a',
  prod: 'Token b06018a0bb7aa813dedddb071db7db5cda58c48a',
};

const token = selectToken(apiTokens);

const ensembleProviderLookupConfig: IndividualLocalClientConfig = {
  // copy base level ensemble config
  ...ensembleConfig,
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'ensemblehp-providerlookup',

  FORM_VARIANT: ENSEMBLE_FORM,
  SHOW_REGION_SELECTOR: false,

  API_TOKEN: token,
  EMBOLD_CLIENT: ENSEMBLE_PROVIDER_LOOKUP,

  // other
  LOGIN_NETWORK_NAME: 'ensembleProviderLookupUserId',
};

export default ensembleProviderLookupConfig;
